import { client } from './Client';

export const api = client;
